import "./canvass-custom-field.component";
import "./canvass-effort.component";
import "./canvass-house-occupant.component";
import "./canvass-regular-field.component";
import "./canvass-status.component";
import "./canvass-survey.component";
import "./canvasser.component";
